import { render, staticRenderFns } from "./ChatModalListItem.vue?vue&type=template&id=20151b40&scoped=true&"
import script from "./ChatModalListItem.vue?vue&type=script&lang=js&"
export * from "./ChatModalListItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatModalListItem.vue?vue&type=style&index=0&id=20151b40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20151b40",
  null
  
)

export default component.exports